import React, { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Lock } from 'lucide-react';

export const EmbeddedPaymentModal = ({ open, onClose, clientSecret, publishableKey }) => {
  const stripePromise = useMemo(
    () => (publishableKey ? loadStripe(publishableKey) : null),
    [publishableKey]
  );

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent
        className="max-w-2xl w-[95vw] max-h-[90vh] overflow-y-auto p-0 border-zinc-200"
        data-testid="embedded-payment-modal"
      >
        <DialogHeader className="px-6 pt-6 pb-3 border-b border-zinc-100">
          <DialogTitle className="font-heading text-xl font-bold text-zinc-950 flex items-center gap-2">
            <Lock className="w-5 h-5 text-emerald-600" />
            Secure Payment
          </DialogTitle>
          <DialogDescription className="text-sm text-zinc-500">
            Complete your payment securely without leaving this page.
          </DialogDescription>
        </DialogHeader>
        <div className="p-4 sm:p-6" data-testid="embedded-checkout-container">
          {stripePromise && clientSecret ? (
            <EmbeddedCheckoutProvider
              stripe={stripePromise}
              options={{ clientSecret }}
            >
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          ) : (
            <p className="text-center text-zinc-500 py-8" data-testid="embedded-checkout-error">
              Unable to load the payment form. Please try again or contact support.
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
